import { cn } from "@/shared/lib/utils";

interface DataTableCenteredCellProps {
  children: React.ReactNode | JSX.Element;
  className?: string;
}

export const DataTableCenteredCell = ({
  children,
  className,
}: DataTableCenteredCellProps) => {
  return (
    <div
      className={cn(
        "center flex h-10 flex-col items-center justify-center gap-2 truncate text-center text-textColor",
        className,
      )}
    >
      {children}
    </div>
  );
};
